import styled from 'styled-components'
import { colors } from '../../styles/vars/colors.style'
import { easings } from '../../styles/vars/easings.style'
import { mq } from '../../styles/vars/media-queries.style'

const overlayTransitionDuration = 0.4

export const VimeoPlayerWrapper = styled.div`
  ${({ fluid, dimensions, maxWidthVW, maxHeightVH }) => {
    if (fluid && dimensions) {
      return `
        width: 94vw;
        height: ${(dimensions[1] / dimensions[0]) * 94}vw;
        max-width: ${(dimensions[0] / dimensions[1]) * 94}vh;
        max-height: 94vh;

        ${mq.tabletL} {
          width: ${maxWidthVW}vw;
          height: ${(dimensions[1] / dimensions[0]) * maxWidthVW}vw;
          max-width: ${(dimensions[0] / dimensions[1]) * maxHeightVH}vh;
          max-height: ${maxHeightVH}vh;
        }
      `
    }
  }}
`

export const VimeoPlayerMain = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: ${props => props.rounded && '2.4rem'};
  -webkit-mask-image: -webkit-radial-gradient(white, black);

  :before {
    content: '';
    display: block;
    width: 100%;
    height: 0;
    padding-bottom: ${({ dimensions }) =>
      dimensions ? `${(dimensions[1] / dimensions[0]) * 100}%` : '56.25%'};
  }
`

export const VimeoPlayerEmbed = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  visibility: ${props =>
    props.playing || props.autoplay ? 'visible' : 'hidden'};
  transition: visibility 0s ease;
  transition-delay: ${props =>
    props.playing ? '0s' : `${overlayTransitionDuration}s`};

  iframe {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

export const VimeoPlayerOverlay = styled.div`
  position: absolute;
  top: -0.2rem;
  right: -0.2rem;
  bottom: -0.2rem;
  left: -0.2rem;
  transform: translateZ(0);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  pointer-events: ${props => (props.playing ? 'none' : undefined)};
  appearance: none;
  border: none;
  background-color: ${colors.dark};
  opacity: ${props => (props.playing ? 0 : 1)};
  transition: opacity ${overlayTransitionDuration}s ${easings.inOut.default};
`

export const VimeoPlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  color: ${colors.light};
  will-change: transform;
  opacity: ${props => (props.isLoading ? 0.2 : 1)};
  transition: transform 0.2s ${easings.inOut.default},
    opacity 0.2s ${easings.inOut.default};

  :hover,
  :focus {
    transform: translate(-50%, -50%) scale(1.05);
  }
`
